import axios from 'axios'
import globals from '../config/appconfig'
import React from "react";
import Enums from "../utils/Enums.json"
import OggettiUtili from "../utils/OggettiUtili.json"
// i18next.init({
//     interpolation: {escapeValue: false},  // React already does escaping
//     lng: globals.lingua_default,                              // language to use
//     resources: {
//         en: {
//             common: common_en               // 'common' is our custom namespace
//         },
//         it: {
//             common: common_it               // 'common' is our custom namespace
//         },
//     },
// });

// Add a request interceptor

class Interceptor {

    constructor() {
        this.addResponseInterceptor()
    }


    addResponseInterceptor = () => {

        let urlComuni, urlProvince, urlSigleProvince, urlNazioni, urlAssistenti, urlSportelli, urlReport, urlApms,
            urlAnagrafica, url = null

        let pathMicroservizi = OggettiUtili.pathMicroservizi


        // Add a response interceptor
        axios.interceptors.response.use(
            response => {
                // Do something with response data
                console.log("[INTERCEPTOR] Response from " + response.config.url);
                console.log(response);
                urlComuni = response.config.url.includes("/comuni");
                urlProvince = response.config.url.includes("/province");
                urlSigleProvince = response.config.url.includes("/sigleProvince");
                urlNazioni = response.config.url.includes("/nazioni");
                urlAssistenti = response.config.url.includes("/assistenti");
                urlSportelli = response.config.url.includes("/sportelli");
                urlReport = response.config.url.includes("/report");
                urlApms = response.config.url.includes("/utenti");
                urlAnagrafica = response.config.url.includes("/anagraf");
                url = response.config.url
                return response;
            },
            error => {
                // Do something with response error
                console.log("[INTERCEPTOR] Error on response from: ", error?.config?.url);
                console.log(error);

                url = error?.config?.url ?? ""
                let identificativoToaster
                pathMicroservizi.forEach(element => {
                    if (url && url.includes(element.path)) {
                        let timestamp = new Date().toISOString().toString()
                        let timestampModificato = timestamp.replace(/[-T:Z.]/g, "")
                        identificativoToaster = element.codice + "-" + timestampModificato
                    }
                })


                let erroriEspliciti = globals["errori-espliciti"] === "true"

                urlAssistenti = url.includes("/assistenti")
                urlSportelli = url.includes("/sportelli")
                urlReport = url.includes("/report")
                urlApms = url.includes("/utent")
                urlAnagrafica = url.includes("/anagraf") || url.includes("candidat");

                let tipoToaster = urlAssistenti || urlSportelli || urlReport || urlApms || urlAnagrafica ? Enums.TOASTERTYPE.ERROR.descrizione : Enums.TOASTERTYPE.SUCCESS.descrizione

                let text = erroriEspliciti && error.response && error.response.data
                    ? error.response.data.path + " - " + error.response.data.message
                    : "Operazione momentaneamente non disponibile"

                /*if (error.response.status === 404) {
                    window.alert(Enums.TOASTERTYPE.SUCCESS.descrizione, "La ricerca non ha prodotto risultati", identificativoToaster);
                } else if (error.response.status >= 400 ){
                    window.alert(tipoToaster, text, identificativoToaster);
                }*/
                console.log(error.response);

                return Promise.reject(error);
            }
        );

    }

}

export default Interceptor


